export enum ScoutProvider {
  Imap = 'imap',
  Google = 'google',
  Microsoft = 'microsoft',
}
